import { render, staticRenderFns } from "./OrderHistoryDropdown.vue?vue&type=template&id=0cfe95f0&scoped=true"
import script from "./OrderHistoryDropdown.vue?vue&type=script&lang=js"
export * from "./OrderHistoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryDropdown.vue?vue&type=style&index=0&id=0cfe95f0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe95f0",
  null
  
)

export default component.exports